import * as React from 'react';
//@ts-ignore
import moment from 'moment';
import ICertificate from './models/ICertificate';
import ILS5Certificate from './models/ILS5Certificate';

//@ts-ignore
import './LookupCert.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/pro-light-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import CertMetrics from './CertMetrics';


interface ILookupCertProps {

}

interface ILookupCertState {
    certificateId: string;
    error?: string;
    ls5Cert?: ILS5Certificate;
}

export default class LookupCert extends React.PureComponent<ILookupCertProps, ILookupCertState> {
    constructor(props: ILookupCertProps) {
        super(props);
        this.state = {certificateId: ""};
    }

    //@ts-ignore
    async doLookup() {
        if (this.state.certificateId == null || this.state.certificateId.length === 0)
            this.setState({ error: "Please specify a Certificate Id." });
        else {
            if (this.state.certificateId.match(/^6/) != null) {
                const response = await fetch(`/api/certification/${this.state.certificateId}`);
                if (response.status === 200) {
                    let cert = await response.json() as ICertificate;
                    window.location.assign(`${window.location.origin}/verifycert/${cert.certificateId}`);
                }
                else {
                    this.setState({ error: "The Certificate Id you requested could not be found." });
                }
            }
            else {
                const response = await fetch(`/api/certification/ls5/${this.state.certificateId}`);
                if (response.status === 200) {
                    let cert = await response.json() as ILS5Certificate;
                    this.setState({ error: undefined, ls5Cert: cert });
                }
                else {
                    this.setState({ error: "The Certificate Id you requested could not be found." });
                }
            }
        }
    }

    render() {
        return <div className="lookupCert">
            <h1>Verification</h1>
            <p>Enter a CompTIA Competency Assessment Certificate ID or a TestOut Certification Certificate ID to verify.</p>
            <div>
                <div>
                    <span>Certificate Id</span><span className="required">Required</span>
                    <div>
                        <input type="text" value={this.state.certificateId} onKeyPress={(e) => { if (e.key === "Enter") this.doLookup() }} onChange={(e) => { this.setState({ certificateId: e.target.value, ls5Cert: undefined }) }} />
                        <a className="button" onClick={() => { this.doLookup() }}><FontAwesomeIcon icon={faMagnifyingGlass as IconProp} /></a>
                    </div>
                </div>
                {this.state.ls5Cert != null && <div className="ls5Cert">
                    <div>{this.state.ls5Cert.certificateTitle}</div>
                    <div>
                        <div>Awarded to {this.state.ls5Cert.candidateName} on {moment(this.state.ls5Cert.certificateDate).format('M/D/yyyy')}</div>
                        <div>Certificate Id: {this.state.ls5Cert.certificateId}</div>
                        <div>Candidate Id: {this.state.ls5Cert.candidateId}</div>
                    </div>
                </div>}
                {this.state.error != null && this.state.error.length > 0 && <div className="error">{this.state.error}</div>}
                {(this.state.error == null || this.state.error.length === 0) && this.state.ls5Cert == null}
            </div>
            <CertMetrics />
        </div>;
    }
}